// This is a polyfill for the currently broken services to ease
// migration. Once user-service is fixed, we can remove this (and the calling logic)
function parseIfString(data) {
  if (typeof data === 'string') {
    return JSON.parse(data);
  }
  return data;
}

function parseIfStringSafe(data, errorValue = null) {
  try {
    return parseIfString(data);
  } catch (err) {
    return errorValue;
  }
}

export function cleanupRole(rawRole) {
  return {
    ...rawRole,
    available_actions: parseIfStringSafe(rawRole.available_actions, []),
  };
}

export function cleanupDetail(rawDetail) {
  return {
    ...rawDetail,
    styling: parseIfString(rawDetail.styling),
  };
}

export function cleanupMembership(rawMembership) {
  return {
    ...rawMembership,
    role: cleanupRole(rawMembership.role),
    detail: cleanupDetail(rawMembership.detail),
  };
}


export function cleanupOrganization(rawOrg) {
  return {
    ...rawOrg,
    available_actions: parseIfStringSafe(rawOrg.available_actions, []),
    organization_detail: cleanupDetail(rawOrg.organization_detail),
    roles: rawOrg.roles.map(cleanupRole),
  };
}

export function cleanupUser(rawUser) {
  return {
    ...rawUser,
    memberships: rawUser.memberships.map(cleanupMembership),
  };
}
